import React, { ReactElement, ReactFragment } from 'react';
import { isFragment } from 'react-is';

export function toArray(
  children?: ReactElement | ReactElement[] | ReactFragment
): React.ReactElement[] {
  let ret: ReactElement[] = [];
  if (children === undefined) {
    return ret;
  }

  if (Array.isArray(children)) {
    ret = ret.concat((children as ReactElement[]).flatMap((it) => toArray(it)));
  } else if (isFragment(children) && (children as ReactElement).props) {
    ret = ret.concat(toArray((children as ReactElement).props.children));
  } else {
    React.Children.forEach(children as ReactElement, (child) => {
      ret.push(child);
    });
  }

  return ret;
}